<template>
  <s-main-panel v-if="loaded" toolbar :scrollbar="true">
    <association-budget-dimanche-dialog v-model="showBudgetDimancheDialog" :associationId="associationId" @ />
    <template v-slot:actions>
      <v-spacer />
      <v-btn color="info" tile dark @click="downloadBudget()">Budget Fériés</v-btn>
      <v-btn color="info" tile dark @click="openBudgetDimanche()">Budget Dimanche</v-btn>
    </template>
    <v-container fluid>
      <v-row v-if="!editing">
        <v-col cols="12"></v-col>
      </v-row>
    </v-container>
  </s-main-panel>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import AssociationBudgetDimancheDialog from './association-budget-dimanche-dialog.vue'

export default {
  name: 'association-detail',
  components: { AssociationBudgetDimancheDialog },
  data() {
    return {
      editing: false,
      showBudgetDimancheDialog: false,
    }
  },
  computed: {
    ...mapGetters({
      getAssociationById: 'etablissement/getAssociationById',
      isInRole: 'security/isInRole',
    }),
    loaded() {
      return this.association !== undefined
    },
    associationId() {
      return parseInt(this.$route.params.associationId, 10)
    },
    association() {
      return this.getAssociationById(this.associationId)
    },
  },
  methods: {
    ...mapActions({
      fetchBudget: 'etablissement/fetchBudget',
    }),
    downloadBudget() {
      this.fetchBudget(this.associationId)
    },
    openBudgetDimanche() {
      this.showBudgetDimancheDialog = true
    },
  },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped></style>
